import Vue                from 'vue';
import Router             from 'vue-router';

import HomePage           from '@/pages/HomePage';
import MenusIndexPage     from '@/pages/menu/MenusIndexPage';
import MenuShowPage       from '@/pages/menu/MenuShowPage';
import BasketPage         from '@/pages/checkout/BasketPage';
import CheckoutSuccess    from '@/pages/checkout/CheckoutSuccessPage';
import CheckoutFailure    from '@/pages/checkout/CheckoutFailurePage';

import Terms              from '@/pages/TermsPage';

import ErrorPage          from '@/pages/ErrorPage';
import NotFound           from '@/pages/NotFound';

Vue.use(Router);

const applicationRouter =  new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/menus',
      name: 'menus',
      component: MenusIndexPage,
    },
    {
      path: '/menus/:menuName',
      name: 'menu-show',
      component: MenuShowPage,
    },
    {
      path: '/checkout/basket',
      name: 'basket',
      component: BasketPage,
    },
    {
      path: '/checkout/success',
      name: 'success',
      component: CheckoutSuccess,
    },
    {
      path: '/checkout/failure',
      name: 'failure',
      component: CheckoutFailure,
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage,
    },
    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' },
  ],
});

applicationRouter.afterEach(() => {
  window.scrollTo(0, 0);
});

export default applicationRouter;
